import { ABPopupMessageLayout } from '../../../common/lookups/Layouts/ABLayouts';
import { OMCodesLookupLayout, OMCodeTypesLookupLayout } from '../../../common/lookups/Layouts/OMLayouts';
const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CodeType",
                "tableName": "OMCODES",
                "label": "Type",
                "type": "lookup",
                "layout": OMCodeTypesLookupLayout({valueExpr:'Description', displayExpr:'Description'}),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code",
                "tableName": "OMCODES",
                "label": "Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Description1",
                "tableName": "OMCODES",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "OMCODES",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Comment",
                "tableName": "OMCODES",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreationDateTime",
                "tableName": "OMCODES",
                "label": "Creation Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "CreationUserId",
                "tableName": "OMCODES",
                "label": "Creation User",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "OMCODES",
                "label": "Last Update Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "",
        "fields": [
            {
                "name": "LastUpdateUserId",
                "tableName": "OMCODES",
                "label": "Last Update User",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    }
];

const HeaderLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CodeType",
                "tableName": "OMCODES",
                "label": "Type",
                "type": "lookup",
                "layout":OMCodeTypesLookupLayout({valueExpr:'CodeType', displayExpr:'Description'}),
                "lookupDisplayMode": "grid",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code",
                "tableName": "OMCODES",
                "label": "Code",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description1",
                "tableName": "OMCODES",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "OMCODES",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Comment",
                "tableName": "OMCODES",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
     
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
           
            {
                "name": "PopupMessage",
                "tableName": "OMCODES",
                "label": "Popup Message",
                "type": "lookup",
                "layout": ABPopupMessageLayout({ tableName: 'OMCODES' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            
        ]
    }
];

export { SearchLayout, HeaderLayout };

